import {z} from 'zod';

const IMPORTER_ORDER_REF_MAX_LENGTH = 255;

export const importerOrderRefSchema = z.string().max(IMPORTER_ORDER_REF_MAX_LENGTH);
